/* -------------------------------------------------------------------------- */
/*                                   TITLES                                   */

const create = {
	complete: {
		overview: {
			account_row_title: "daDup Storage Account",
			desc: "Bekijk hier het overzicht van het daDup Storage account die u gaat bestellen.",
			description: "Omschrijving",
			relation: "Relatie",
			title: "Configuratie Overzicht",
		},
		page_title: "daDup Account Bestel Overzicht",
		product_details_desc: "Pas hier uw daDup Storage Account gegevens aan.",
		product_details_title: "daDup Storage Account Details",
		product_header_title: "Product Overzicht",
		product_title: "daDup Storage Account",
		submit_button: "Aanmaken",
		success_toast: "daDup succesvol aangemaakt!",
	},
	config: {
		description: "Bepaal een naam voor uw daDup account.",
		placeholder_description: "Optionele omschrijving",
		placeholder_description_helper: "Geef uw daDup account een omschrijving.",
		section_label: "daDup Account Informatie.",
		title: "daDup Account Configuratie",
	},
	header: "daDup Account Aanmaken",
	other_info: {
		description:
			"Kies optioneel een relatie waar u dit account aan wilt koppelen. Het koppelen van een relatie heeft verder geen invloed op de werking. U kunt ook andere producten aan een relatie koppelen en zo zien wat een relatie allemaal gebruikt",
		options: {
			enabled: "Koppelen aan relatie",
		},
		section_label: "Koppelen aan relatie",
		title: "Overige informatie",
	},
	select_type: {
		description: "Kies het daDup account type.",

		options: {
			// # TODO: make this like pbs. for future dadup types.
			default: "S3 storage",

			disabled_text: "Dit is niet beschikbaar",
		},
		price_suffix: "p/m per",
		title: "daDup Account uitvoering",
	},
};

export default create;
